import { Typography } from '@mui/material';

import React from 'react';

export interface SlideParagraphProps {
  readonly children: React.ReactNode;
  style?: React.CSSProperties;
}

export function SlideParagraph({
  children,
  style,
}: SlideParagraphProps): React.ReactElement {
  return (
    <Typography
      component="p"
      sx={{
        color: '#000000',
        fontFamily: 'Roboto',
        fontWeight: '400',
        fontSize: '15px',
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
